import React, { Component } from "react";
import PageOpeningSplash from './PageOpeningSplash';
import PageMelbournesFinest from './PageMelbournesFinest';
import PageDsylva from './PageDsylva';
import PageDsylvaSplash from './PageDsylvaSplash';
import PageRetailers from './PageRetailers';
import PageYarraBend from './PageYarraBend';
import PageLeasing from './PageLeasing';
import PageGettingHere from './PageGettingHere';
import PageFooter from './PageFooter';
import PageContent from './PageContent';

export default class PageBlocks extends Component {

	constructor(){
		super()
		this.state = {
			open: 		false,
			maxHeight: 0,
		}
		this.handleClick = this.handleClick.bind(this);
	}
    
    handleClick(_evt) {
	    _evt.preventDefault();  
	    let id = _evt.currentTarget.getAttribute('data-id');
	    let top = document.getElementById(id).offsetTop;
	    window.scroll({
			top: top, 
			left: 0, 
			behavior: 'smooth'
		});
    }
    
	render () {
		
		const post = this.props.post; 
		
		return (
			<>
				{!post.content &&
					
					<>
					
						<ul className="c-nav">
							{post.retailers &&
								<li className="c-nav__item">
									<a href="#" className="c-nav__link" data-id="retailers" dangerouslySetInnerHTML={{__html:"Retailers"}} onClick={this.handleClick}></a>
								</li>
							}
							{post.mf_text && post.mf_image_src &&
								<li className="c-nav__item">
									<a href="#" className="c-nav__link" data-id="melbournes-finest" dangerouslySetInnerHTML={{__html:"Melbourne's Finest"}} onClick={this.handleClick}></a>
								</li>
							}
							{post.ad_heading && post.ad_image_src && post.ad_text &&
								<li className="c-nav__item">
									<a href="#" className="c-nav__link" data-id="adam-dsylva" dangerouslySetInnerHTML={{__html:"Adam D'Sylva"}} onClick={this.handleClick}></a>
								</li>
							}
							
							{post.yb_gallery &&
								<li className="c-nav__item">
									<a href="#" className="c-nav__link" data-id="yarrabend" dangerouslySetInnerHTML={{__html:"YarraBend"}} onClick={this.handleClick}></a>
								</li>
							}
							{post.ls_heading && post.ls_image_src && post.ls_text &&
								<li className="c-nav__item">
									<a href="#" className="c-nav__link" data-id="leasing" dangerouslySetInnerHTML={{__html:"Leasing"}} onClick={this.handleClick}></a>
								</li>
							}
							{post.gh_heading && post.gh_image_src && post.gh_text &&
								<li className="c-nav__item">
									<a href="#" className="c-nav__link" data-id="getting-here" dangerouslySetInnerHTML={{__html:"Getting Here"}} onClick={this.handleClick}></a>
								</li>
							}
						</ul>
						{post.os_gallery &&
							<PageOpeningSplash post={post}></PageOpeningSplash>
						}
						{post.retailers &&
							<PageRetailers post={post}></PageRetailers>
						}
						{post.mf_text && post.mf_image_src &&
							<PageMelbournesFinest post={post}></PageMelbournesFinest>
						}
						{post.ad_heading && post.ad_image_src && post.ad_text &&
							<PageDsylva post={post}></PageDsylva>
						}
						{post.ad_splash_image_src && post.ad_splash_text &&
							<PageDsylvaSplash post={post}></PageDsylvaSplash>
						}
						
						{post.yb_gallery &&
							<PageYarraBend post={post}></PageYarraBend>
						}
						{post.ls_heading && post.ls_image_src && post.ls_text &&
							<PageLeasing post={post}></PageLeasing>
						}
						{post.gh_heading && post.gh_image_src && post.gh_text &&
							<PageGettingHere post={post}></PageGettingHere>
						}
						{post.ftr_background_image_src &&
							<PageFooter post={post}></PageFooter>
						}
						
					</>
				}
				{post.content &&
					<>
						<PageContent post={post}></PageContent>
						{post.ftr_background_image_src &&
							<PageFooter post={post}></PageFooter>
						}
					</>	
				}
			</>
		)
	}
}
